export enum ReportRequestTypes {
  unknown = 0,
  onlinePdg = 1,
  downloadPdg = 2,
  onlineTdg = 3,
  downloadTdg = 4,
  onlineCdg = 5,
  downloadCdg = 6,
  onlineUsersReport = 7,
  downloadUsersReport = 8,
  onlineCampaignTdgReport = 9,
  downloadCampaignTdgReport = 10,
  onlineAdvancedReport = 11,
  downloadAdvancedReport = 12,
  onlineCompareReport = 13,
  downloadCompareReport = 14,
  downloadTrackMyJourney = 16,
  onlineCampaignCdgReport = 17,
  downloadCampaignCdgReport = 18,
  bulkdownloadPdgReport = 19,
  onlineOrganisationCdgReport = 20,
  downloadOrganisationReport = 21,
  downloadAllDataReport = 22,
  downloadPersonalEdition = 23
}
